<ng-template #numberOfBorrowers let-stepComponent="stepComponent">
  <ng-container *transloco="let t">
  <form #numberOfBorrowersForm="ngForm" novalidate id="numberOfBorrowersForm" name="numberOfBorrowersForm">
    <div class="fv-row">
      <div class="row mb-10">
        <div class="col">
          <label class="btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4"
            [ngClass]="{'active': hasCoBorrowers}">
            <input type="radio" class="btn-check" name="yes" id="yes" (click)="onYesSelected()"
              [disabled]="!wizardFlowService.canManageCoBorrowers" />
            <span class="fw-bolder fs-3">{{ t('common.yes') }}</span>
          </label>
        </div>
        <div class="col">
          <label class="btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4"
            [ngClass]="{'active': hasCoBorrowers === false}">
            <input type="radio" class="btn-check" id="no" name="no" (click)="onNoSelected()"
              [disabled]="!wizardFlowService.canManageCoBorrowers" />
            <span class="fw-bolder fs-3">{{ t('common.no') }}</span>
          </label>
        </div>
      </div>
      @if (hasCoBorrowers) {
        <div class="row">
          <div class="col-md-4 fv-row">
            <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span class="required">{{ t('wizard.numberOfBorrowers.howManyPeople') }}</span>
            </label>
            <div class="position-relative">
              <input type="number" [(ngModel)]="numberOfCoBorrowers" (ngModelChange)="onNumberOfCoBorrowersChanged()"
                required min="1"
                [ngClass]="{'is-invalid' : numberOfBorrowersOnLoan && numberOfBorrowersOnLoan.touched && numberOfBorrowersOnLoan.invalid}"
                class="form-control form-control-solid" placeholder="" name="numberOfBorrowers"
                #numberOfBorrowersOnLoan="ngModel" [disabled]="!wizardFlowService.canManageCoBorrowers" />
              <div class="invalid-feedback">{{ t('wizard.numberOfBorrowers.enterNumberRequired') }}</div>
            </div>
          </div>
        </div>
      }
    </div>
  </form>
  </ng-container>
</ng-template>

<wizard-step-template [stepMainTemplate]="numberOfBorrowers" [step]="step" [stepComponent]="this">
</wizard-step-template>
